import React, { useState } from 'react';
import Modal from 'v3/components/Modal';
import { Row, Col } from 'react-bootstrap';
import { Select, Button } from 'v3/components';
import TextArea from 'v3/components/TextArea';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import { validateEndLotOccurrence } from '../utils';

export default function EndLotOccurrenceModal({
  isOpen,
  isClosed,
  occurrencesOptions,
  travelId,
  fetchTravelOccurrences,
}) {
  const snackbar = useSnackbar();

  const [data, setData] = useState({});
 const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const isDateValid = await validateEndLotOccurrence(
        data.occurrenceType,
        data.description,
        setErrors,
      );

      if (!isDateValid) {
        snackbar.show('Verifique os campos obrigatórios.', { type: 'error' });
        return;
      }

      await cooperplaceApi.put(`occurrences/lot/conclude/${travelId}`, {
        description: data.description,
        occurrenceTypeId: data.occurrenceType?.id,
      });

      await fetchTravelOccurrences();

      snackbar.show('Ocorrências concluídas com sucesso!', { type: 'success' });
      handleClose();
    } catch (err) {
      setLoading(false);
      snackbar.show('Erro ao concluir ocorrências.', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setData({});
    setErrors({});
    isClosed();
  };

  return (
    <>
      <Modal
        show={isOpen}
        handleClose={handleClose}
        size="lg"
        heading="Concluir ocorrências em lote"
        body={
          <>
            <Row
              style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '1rem' }}
            >
              <Col lg={6} md={6} sm={6} xs={12}>
                <Select
                  label="Tipo ocorrência *"
                  value={data.occurrenceType}
                  onChange={(value) => setData({ ...data, occurrenceType: value })}
                  options={occurrencesOptions.filter(
                    (option) => option.slug === 'TEMPERATURE_LOAD' || option.slug === 'TELEMETRY',
                  )}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  error={errors?.occurrenceType}
                  isDisabled={loading}
                />
              </Col>
              <Col>
                <TextArea
                  label="Descrição *"
                  placeholder="Adicionar descrição *"
                  value={data.description}
                  onChange={(e) => setData({ ...data, description: e.target.value })}
                  resizable={false}
                  error={errors?.description}
                  disabled={loading}
                />
              </Col>
            </Row>
          </>
        }
        footer={
          <Row>
            <Col>
              <Button variant="secondary" onClick={handleClose} loading={loading}>
                Cancelar
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="primary" onClick={handleSubmit} loading={loading}>
                Concluir
              </Button>
            </Col>
          </Row>
        }
      />
    </>
  );
}
